module.exports = __webpack_public_path__ + "img/jj.495bb526.png";